module.exports = __webpack_public_path__ + "static/media/p1c.df49d717.ogg";